<div class="img-container">
  <app-swiper-slides [slides]="data.urls"
                     [width]="data.width"
                     [aspectRatio]="1 / data.ratio"
                     [autoPlay]="false"
                     [allowTouchMove]="false"
                     [hideBullet]="true"
                     [initialSlide]="data.index"/>
</div>
<button class="dialog-close" appFocusRemove mat-dialog-close>
  <app-image-loading src="assets/icon_close_new.svg" alt="關閉" i18n-alt
                     [clickable]="true"
                     [targetWidth]="45"
                     [targetHeight]="45"/>
</button>
